.home {
  position: relative;
  z-index: 1;
  /* Edge + chrome clearance is handled by the live stage safe-area. */
  padding: 0;
  /* Fill the live safe box, not the raw viewport — 100vh would overflow
   * the safe area (by the top+bottom insets) and clip content at the
   * bottom edge. */
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.empty {
  position: relative;
  z-index: 1;
  padding: var(--token-space-2xl);
  font-family: var(--token-font-ui);
  color: var(--token-card-bg);
}
